import * as types from './types'

export default {
  [types.SET_ISSUE](state, data) {
    state.issue = data
  },
  [types.SET_ISSUES](state, data) {
    state.issues = []
    let _issues = {
      count: 0,
      items: []
    }
    if (data !== null && data !== undefined) {
      _issues.count = data[0].Pager.TotalItems
      _issues.items = data
      state.issues = _issues
    }
  },
  [types.UPDATE_ISSUE](state, data) {
    for (let issue of state.issues.items) {
      if (issue.Id === data.Id) {
        issue.Category.Id = data.Category.Id
        issue.CommonIssue.Id = data.CommonIssue.Id
        issue.IsSuccessful = data.IsSuccessful
        issue.UnusualConditions = data.UnusualConditions
        break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/issues/mutations.js